import { FC, ReactNode } from 'react'
import LoginSteps from './loginSteps/LoginSteps'
import LoginProvider from './providers/loginProvider/LoginProvider'

interface LoginContainerProps {
  onLogin: (args: { isHost: boolean }) => void
  onClose?: () => void
  header?: ReactNode
}

const LoginContainer: FC<LoginContainerProps> = ({
  onLogin,
  onClose,
  header,
}) => {
  return (
    <LoginProvider loginCallback={onLogin} onClose={onClose}>
      <LoginSteps header={header} />
    </LoginProvider>
  )
}

export default LoginContainer
